export default __webpack_public_path__ + "static/media/ic-success.352b2473.svg";